import { config } from "@onflow/fcl";
import keys from "./config/keys";

//mainnet
config(keys.fclConfig);

// Service	Testnet	Mainnet
// Dapper Wallet	0x82ec283f88a62e65	0xead892083b3e2c6c
// Ledger	0x9d2e44203cb13051	0xe5cd26afebe62781
